<template>
  <div class="index-feed-list">
    <div v-for="(good, index) in goods" :key="index">
      <!-- 小美帮你选等推荐数据-后期可能会加，勿删 -->
      <!-- <recommend
        v-if="goods.object_type === 3"
        :query-words="good.queryWords"
      ></recommend> -->
      <!-- 广告位-后期可能会加，勿删 -->
      <!-- <mc-image
        v-if="good.object_type === 2"
        class="index-feed-banner"
        :src="good.img || ossImage(720)"
        :mode="'contain'"
        @click="onBannerClick(good, index)"
      >
      </mc-image> -->
      <!-- feed商品 -->
      <feed-good
        v-if="good.object_type === 1 || !good.object_type"
        :good="good"
        :sku-index="index"
        @onTick="onTick"
      >
      </feed-good>
    </div>
    <!-- 暂无商品 -->
    <empty
      v-if="goods.length === 0"
      :desc="'暂无商品'"
      :type="1"
      :img="'Empty'"
      class="empty-box"
    ></empty>
  </div>
</template>
<script>
import Empty from '@/common/layout/empty/index'
import FeedGood from './components/FeedGood'
import { calcGoodsList } from '@/utils/goods/util'

export default {
  components: {
    FeedGood,
    Empty
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      goods: [], // 需要展示的商品列表
      goodsCache: [] // 商品缓存
    }
  },
  watch: {
    list(newList) {
      this.handleListData(newList)
    }
  },
  created() {
    this.handleListData(this.list)
  },
  methods: {
    // 处理列表数据
    handleListData(list) {
      if (Array.isArray(list) && list.length) {
        this.goods = list
          .map(item => {
            /**
             * object_type 商品类型
             * 2：广告位
             * 3：小美帮你选
             */
            if (item.object_type === 2 || item.object_type === 3) {
              return item
            } else {
              const calcedGoodsList = calcGoodsList([item]) || []
              return calcedGoodsList[0]
            }
          })
          .filter(item => item)
      } else {
        this.goods = []
      }
    },
    onTick(evt, data) {
      // eslint-disable-next-line vue/custom-event-name-casing
      this.$emit('onTick', evt, data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.index-feed-list {
  margin: 0.2rem 0.2rem 0 0.2rem;
  @include flex(row, space-between, flex-start, wrap);

  .index-feed-banner {
    display: block;

    width: 7.1rem;
    margin-bottom: 12px;
  }
}
</style>
